<lib-navigation
  (changeVisibility)="visibilityUpdated($event)"
  (sortUpdated)="sortUpdated($event)"
  [availableToAdd]="availableToAdd"
  [bottomMenu]="bottomMenu"
  [hasUpload]="(serviceUpload.getTotalFilesInProgress() | async) > 0"
  [mainMenu]="mainMenu"
  [menuConfigNotLoaded]="navigationConfigNotLoaded"
  [organizations]="mineOrganizations$ | async"
  [shouldOpenAdd]="shouldOpenAdd$ | async"
  [showCommentsIcon]="true"
  [sortOrder]="currentSortOrder$ | async"
  [uploadDone]="serviceUpload.getTotalFilesInUploaded() | async"
  [uploadInProgress]="serviceUpload.getTotalFilesInProgress() | async"
  [appTasksInProgress]="zalamoLocalClientService.tasksInProgress$ | async"
  [hasApp]="zalamoLocalClientService.isConnected | async"
  (showAppTasks)="zalamoLocalClientService.showTasks()"
  [hasZalamoPrint]="true"
  (logout)="logout()"
></lib-navigation>
<app-fiscal-machine-state-question></app-fiscal-machine-state-question>
<div #container class="container">
  <div class="content">
    @if (queriesInProgress$ | async) {
      <mat-progress-bar
        mode="query"
      ></mat-progress-bar>
    }
    @if (zalamoLocalClientService.lastError$ | async; as localClientError) {
      <div class="local-client-error" role="alert">
        {{ localClientError }}
      </div>
    }
    <router-outlet></router-outlet>
  </div>

  @if (isSupportVisible | async) {
    <lib-support-container
      (closeMe)="close()"
      (hideMe)="hide()"
      [isChat]="isChatOpen | async"
      [isFaq]="isFaqOpen | async"
    ></lib-support-container>
  }
</div>
@if (!(isMobile | async)) {
  <lib-customization-icon class="noPrint"></lib-customization-icon>
  <lib-support-icon-view class="noPrint"></lib-support-icon-view>
}
@if (isOffline$ | async) {
  <div class="offline">
    <svg
      id="Layer_1"
      enable-background="new 0 0 512 512"
      height="512"
      viewBox="0 0 512 512"
      width="512"
      xmlns="http://www.w3.org/2000/svg"
      >
      <path
        d="m155.985 205.071c-29.966 12.767-56.94 31.021-80.175 54.256-3.124 3.125-7.219 4.687-11.313 4.687s-8.189-1.562-11.313-4.686c-6.248-6.249-6.249-16.379 0-22.627 26.143-26.143 56.51-46.689 90.259-61.069 8.129-3.463 17.528.319 20.991 8.448s-.319 17.527-8.449 20.991zm-43.555-73.607c-4.107-7.824-13.778-10.837-21.604-6.73-31.664 16.622-60.646 37.976-86.14 63.469-6.249 6.249-6.249 16.379 0 22.627 3.124 3.125 7.218 4.687 11.313 4.687 4.094 0 8.189-1.563 11.313-4.686 23.21-23.209 49.583-42.644 78.386-57.763 7.825-4.108 10.838-13.78 6.732-21.604zm106.564 108.577c-2.283-8.536-11.046-13.609-19.591-11.323-36.833 9.851-70.625 29.38-97.723 56.479-6.249 6.248-6.249 16.379 0 22.627 3.124 3.124 7.219 4.686 11.313 4.686s8.189-1.562 11.313-4.686c23.128-23.128 51.955-39.793 83.363-48.193 8.538-2.282 13.608-11.053 11.325-19.59zm288.319-51.838c-47.753-47.753-107.667-80.762-173.265-95.459-61.155-13.701-124.704-11.057-184.333 7.583l-67.77-67.771c-6.248-6.249-16.379-6.249-22.627 0-6.249 6.248-6.249 16.379 0 22.627l381.891 381.89c3.124 3.125 7.219 4.687 11.313 4.687s8.189-1.562 11.313-4.687c6.249-6.248 6.249-16.379 0-22.627l-152.88-152.881c28.743 8.858 55.093 24.615 76.738 46.259 3.124 3.125 7.219 4.687 11.313 4.687s8.189-1.562 11.313-4.687c6.249-6.248 6.249-16.379 0-22.627-37.313-37.313-86.552-59.704-139.103-63.369l-36.272-36.273c74.306-6.192 147.78 20.307 201.245 73.773 3.124 3.125 7.218 4.687 11.313 4.687s8.189-1.563 11.313-4.686c6.249-6.249 6.249-16.379 0-22.627-66.396-66.398-160.192-95.853-252.424-79.697l-30.8-30.8c110.735-28.554 227.267 2.801 309.094 84.627 3.124 3.124 7.219 4.686 11.313 4.686s8.189-1.562 11.313-4.687c6.252-6.249 6.252-16.38.002-22.628zm-236.42 117.531c-.072-8.836-7.263-15.906-16.131-15.868-39.504.325-76.646 15.89-104.585 43.828-6.249 6.249-6.249 16.379 0 22.627 3.124 3.125 7.218 4.687 11.313 4.687s8.189-1.563 11.313-4.686c21.965-21.964 51.165-34.201 82.222-34.457 8.836-.073 15.941-7.295 15.868-16.131zm28.641 73.296c11.629 11.628 18.032 27.089 18.032 43.534s-6.403 31.906-18.032 43.534c-12.001 12.001-27.771 18.003-43.534 18.003-15.768 0-31.53-6-43.534-18.004-11.629-11.628-18.032-27.088-18.032-43.534 0-16.445 6.403-31.905 18.032-43.534 24.004-24.005 63.064-24.005 87.068.001zm-13.968 43.534c0-7.897-3.075-15.322-8.659-20.907-5.765-5.764-13.336-8.646-20.907-8.646s-15.143 2.882-20.907 8.646c-5.584 5.584-8.659 13.009-8.659 20.907s3.075 15.322 8.659 20.906c11.529 11.528 30.285 11.528 41.814 0 5.584-5.584 8.659-13.009 8.659-20.906z"
        />
      </svg>
      <h1>Nie masz dostępu do internetu</h1>
      <h2>Podłącz się aby kontynuować</h2>
    </div>
  }
  <ng-template #blackFriday>
    <div class="blackFriday">
      <div class="ct">
        <h1>Black Friday 2024</h1>
      </div>
    </div>
  </ng-template>
